export enum RequiredActionTypes {
    ImplementOnsiteBlog = 2,
    OnsiteBlogApproval = 3,
    OnsiteRecommendationApproval = 4,
    WebsiteAccess = 5,
    SeoContentSurvey = 6,
    PageCreationApproval = 7,
    PageOptimizationApproval = 8
}
